import React, { type ComponentType, type FC } from "react";

import type { WithClassName } from "./contract";

const addClasses = (className = ""): string => {
  return `${className} fs-exclude dd-privacy-hidden`.trim();
};

function withConfidentialData<T extends object>(
  Component: ComponentType<T>,
): FC<T> {
  const withConfidentialData: FC<T & WithClassName> = (props) => {
    return <Component {...props} className={addClasses(props.className)} />;
  };

  return withConfidentialData;
}

export default withConfidentialData;
